export default {
    translation: {
        appTour: {
            title: '消息发送者的产品指南',
            subtitle1: `操作简单如 `,
            subtitle2: '1，2，3',
            text: `由于您是新用户，我们已经为您概述了发送消息所需的 <span class="text-blue-darken-4 font-weight-bold">3</span> 步骤。此外，您还可以通过点击下面的 (<span class="text-blue-darken-4">开始体验全功能</span>) 按钮查看所有功能的介绍。`,
            btn1: `跳过导览`,
            btn2: `给我导览`,
            tourElements: {
                'tour-start': {
                    title: `让我们开始导览吧！`,
                    text: `“电话亭”是您发送消息的工具。`
                },
                'tour-message-content': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">消息内容</span> 输入框...`,
                    text: `这是您输入要通过DaD的真实人类信使进行语音电话呼叫发送的消息的地方。`
                },
                'tour-phone-number': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">电话号码</span> 输入框...`,
                    text: `这是您输入信使用来传递您的消息的电话号码的地方。这个号码可以是收件人的号码，也可以是您自己的号码（例如，如果您想通过第三方进行三方通话）。`
                },
                'tour-delivery-window': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">交付时间窗口</span> 输入框...`,
                    text: `这是您选择希望消息发送的开始和结束时间的地方。`
                },
                'tour-additional-options': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">附加选项</span> 输入框...`,
                    text: `这是一个 <span class="font-weight-bold">可选的</span> 输入框，您可以在这里选择许多不同的选项来定制您的消息传递。`
                },
                'tour-voice-characteristics': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">语音特征</span> 输入框...`,
                    text: `这是您选择信使语音特征的地方。<p class="mt-4 text-caption">有时，确切匹配的语音可能不可用。在这种情况下，选择“要求”复选框会导致您的请求失败。</p>`
                },
                'tour-fluent-spoken-languages': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">流利语言</span> 输入框...`,
                    text: `这是您选择希望消息以哪些语言发送的地方。<p class="mt-4 text-caption">某些信使可能不支持所有语言。如果是这种情况，选择“要求”复选框会导致您的请求失败。</p>`
                },
                'tour-audio-receipt': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">音频回执</span> 输入框...`,
                    text: `这是您选择是否接收消息送达的音频回执的地方。音频回执是消息被送达时的语音录音。<p class="mt-4 text-caption">如果选择此选项，只有在您确认已收到语音回执后，信使才会得到报酬。</p>`
                },
                'tour-important-notes': {
                    title: `<span class="font-weight-bold mx-1 text-blue-darken-4">重要备注</span> 输入框`,
                    text: `这是您可以添加任何希望与信使分享的重要备注的地方。这些备注将帮助信使为您将消息送达收件人。<p class="mt-4 text-caption">选择“私人”复选框将仅对接受您请求的信使显示您的备注。</p>`
                },
                'tour-send': {
                    title: `发送按钮...`,
                    text: `这是您发送消息之前的最后一步。当所有输入有效时，发送按钮会变为蓝色。点击这里发送您的消息。`
                },
                'tour-coin-slot': {
                    title: `硬币插槽...`,
                    text: `这是您可以查看消息总价并获得是否准备好发送的可视指示的地方。硬币插槽会在表单有效时显示“发送”，它也可以作为发送按钮使用。`
                },
                'tour-coin-release': {
                    title: `硬币释放...`,
                    text: `这是一种有趣的方式，可以将信息从“发送者”的信息转换为“信使”的信息。切换硬币释放将更改信息并提供关于如何成为信使的更多信息。`
                },
                'tour-gig-work': {
                    title: `零工工作`,
                    text: `您可以在这里了解更多通过作为信使赚钱的信息并注册。信使仪表板将帮助您跟踪收入并提供如何赚取收入的提示，并且还有自己的导览。`
                },
                'tour-complete': {
                    title: `完整导览 🎉`,
                    text: `恭喜！您已经完成导览。如果想再次查看导览，只需点击 DaD 按钮。`
                }
            }
        },
        profile: {
            defaultMessage: "您的消息在这里。",
            defaultTitle: "您的标题在这里。",
            defaultSubtitle: "您的副标题在这里。",
            placeholderMessage: `这是 DaD 平台。我爱我的爸爸。我也是一个爸爸。`,
            placeholderTitle: "Adrian Wardell",
            placeholderSubtitle: "信使的信使",
        },
        nav: {
            pricing: "定价",
            about: "关于",
            contact: "联系",
            messengers: "信使",
            terms: "条款",
            privacy: "隐私",
            faq: "常见问题",
            blog: "博客",
            business: "商务",
            legal: "法律",
            happyGraduation: "祝您毕业快乐。",
            product: "产品",
            contact: "联系方式",
        },
        head: {
            title: `讲人类语言的信使平台`,
            metaDescription: `DaD 是一个按需平台，真实的人类为您传达消息。无论是业务更新、个人提醒，还是创意沟通，DaD 结合了人类触感的真实性和现代便利性。`,
            metaKeywords: `告密者，零工工作，临时电话，预付电话，暗网，公用电话，人类沟通，匿名消息`,
        },
        pricing: {
            affordable: "负担得起、透明且灵活",
            theGoalIs: "目标简单，提供可持续的定价，既能满足客户也能支持信使。",
            coreFeatures: "核心功能与定价",
            startingCost: "起始成本",
            startingCost2: "每条消息仅需 1.99 美元（信使和平台各自分担 50%）。",
            just: "仅",
            just2: "$0.009",
            justPerWord: `每超过前 100 个单词收取`,
            diverseSpeaker: "多样化的语音选择",
            diverseSpeaker2: "从多种不同语言、口音、性别和风格中选择，满足您的消息需求。",
            globalCoverage: "全球覆盖",
            globalCoverage2: "将消息发送到世界任何地方，按本地偏好和规范定制。",
            humanTouch: "人类触感保证",
            humanTouch2: "每条消息都由真人信使传递，确保同理心和精准度。",
            encrypted: "100% 加密",
            encrypted2: "端到端加密确保您的消息完全保密。",
            flexibleScheduling: "灵活的时间安排",
            flexibleScheduling2: "随时为您安排消息的发送时间。",
            anonymous: "按设计匿名",
            anonymous2: "无需账户，确保发送者和接收者的完全匿名。",
            realTimeProgress: "实时进度跟踪",
            realTimeProgress2: "在每个交付里程碑上获得更新和确认。",
            satisfaction: "满意保证",
            satisfaction2: "如果消息没有按承诺发送，提供退款或重新发送选项。",
            additionalFeatures: "附加功能",
            enhanceYourMessage: "通过可选附加功能增强您的消息传递：",
            expeditedDelivery: "加急配送",
            expeditedDelivery2: "确保您的消息比标准处理时间更快地送达。",
            audioReceipts: "音频回执",
            audioReceipts2: "接收消息交付的详细语音回执。此功能提供保证和透明度，确保您清楚消息何时、如何送达。",
            youOnlyPay: "只为您所需支付—没有隐藏费用或复杂定价结构。我们的系统旨在为简单和高级消息需求提供价值。",
        },
        home: {
            thePlatform: "一个讲",
            speaks: "人类",
            human: "语言",
            joinWaitlist: "加入等待名单",
            toBeFirst: "成为第一个知道我们上线的人！🚀",
            whatIs: "DaD是什么？",
            messageAnyoneAnyVoice: "通过",
            wid1: `一个具有 <span class="font-weight-bold">无与伦比的真实感</span> 的文字转语音服务（因为每个声音都是100%真人，而非AI）。`,
            wid2: `想象一下Uber、DoorDash或Instacart——不过这次传递的不是食物或搭车，而是消息，由一位信使传递给您。`,
            wid3: `一个旨在 <span class="font-weight-bold">连接那些不想、无法或无法说话的人</span> 与那些能说话的人的平台。`,
            wid4: `为有 <span class="font-weight-bold">社交焦虑</span> 不愿说话的人提供的服务。`,
            wid5: `一个工具，帮助您通过代理“发声”，隐匿身份，提供让您有信心 <span class="font-weight-bold">“发声”</span>。`,
            wid6: `一个平台，允许人们通过简单使用他们的声音传递消息来 <span class="font-weight-bold text-green">赚钱</span>。`,
            wid7: `一种通过 <span class="font-weight-bold">安全</span> 渠道并以 <span class="font-weight-bold">公正</span> 的方式传递敏感且 <span class="font-weight-bold">商业至关重要的</span> 信息的方式。`,
            wid8: `字面意义上的“起床呼叫”，由一个真实的人在您最需要时打来。 <span class="font-weight-bold">“起床啦！”</span>`,
            wid9: `一个工具，能用他人的声音向 <span class="font-weight-bold">任何人</span> 发送消息。`
        },
        phoneBooth: {
            earnCash: `赚取现金`,
            onDemand: `按需消息传递，来自`,
            realHumans: `真实的人类`,
            privateDiscreet: `私密、低调、匿名、安全、快速可靠。`,
            whenYouHave: `当你有消息并需要一个声音时，使用DaD。`,
            gigWork: `为有声音的人提供的零工工作。`,
            convenientEasy: `方便、轻松、灵活`,
            yourVoice: `你的声音就是你的工具！`,
            learnMore: `了解更多`,
            signUpNow: `立即注册`,
            country: `美国`,
            coins: `硬币`,
            only: `仅`
        },
        learnAboutMessengers: {
            title1: `什么是信使？`,
            subtitle1: `真实的人用他们的声音赚取传递消息的报酬。`,
            text1: `在DaD平台上，<span class="font-weight-bold">信使</span> 可以完全自由选择何时何地工作以及接什么任务，这使得它非常适合那些寻求自主权并能够管理自己时间的人。`,
            title2: `信使能赚多少钱？`,
            benefits1Title: `随时工作，按你意愿。`,
            benefits1Text: `你可以选择最适合自己的工作时间和任务，让你在管理时间方面拥有极大的灵活性。`,
            benefits2Title: `告别老板的管束。`,
            benefits2Text: `你是自己的老板，不必担心被过度干预，可以远程工作，只需要一部手机和你的声音——避免通勤。`,
            benefits3Title: `跳过漫长的面试流程`,
            benefits3Subtitle: `快速开始赚钱。`,
            benefits3Text: `流程简化，你几乎可以立即开始赚钱，不像其他工作那样需要经历冗长的传统面试。`,
            cards1Title: `基本薪资`,
            cards1Text: `<p class="my-4"><span class="bigger-emoji">💸</span> 每位信使都会根据每个接受的任务获得 <span class="font-weight-bold">基础报酬</span>。报酬金额是 <span class="font-weight-bold">动态计算的</span>，根据消息的长度和其他因素来确定任务的复杂性和所需时间。</p>
<p class="my-4"><span class="bigger-emoji">✨</span> 最棒的是：不同于其他零工工作，你可以在工作信使的同时做其他任务！ <span class="big-emoji">🕒</span><span class="font-weight-bold">最大化你的生产力和收入。</span><p>`,
            cards2Title: `小费收入`,
            cards2Text: `<p class="my-4">所有信使都有机会获得来自满意消息发送者的 <strong>小费</strong><span class="bigger-emoji">💰</span>。<em>优异的表现</em>、<em>及时交付<span class="big-emoji">⏱️</span></em> 和 <em>生动的表达风格</em> 都可能导致更高的小费——而且你 <strong>100%保留小费</strong><span class="big-emoji">💯</span>。</p>`,
            cards3Title: `更多`,
            cards3Text: `无论你是 <span class="font-weight-bold">兼职、全职，还是偶尔做</span>，你都可以根据需要扩大收入。而且，支付处理快速可靠，你可以享受到作为DaD信使带来的灵活性和经济自由。</p>`
        }
    }
}